// Yönlendirme korumaları: oturum, modül izni ve özellik bayrağı. Bayrak kapalıysa ekran yok sayılır (404 gibi ana sayfaya döner).
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import type { Action, Module, PermissionModule } from '@serota/domain';
import { ForbiddenState, Skeleton } from '@serota/ui-web';
import { BUSINESS, CONTROL, isBusinessPath } from '../lib/paths';
import { useSession } from '../lib/session';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useSession();
  const loc = useLocation();
  if (status === 'loading')
    return (
      <div className="sr-auth" aria-busy="true">
        <Skeleton height={40} width={200} />
      </div>
    );
  if (status === 'signedOut') return <Navigate to="/giris" replace state={{ from: loc.pathname }} />;
  return <>{children}</>;
}

export function RequirePerm({
  perm,
  action = 'view',
  flag,
  children,
}: {
  perm: PermissionModule;
  action?: Action;
  flag?: Module;
  children: ReactNode;
}) {
  const { can, flag: hasFlag } = useSession();
  const loc = useLocation();
  if (flag && !hasFlag(flag)) return <Navigate to={isBusinessPath(loc.pathname) ? BUSINESS : CONTROL} replace />;
  if (!can(perm, action))
    return (
      <div className="sr-page">
        <ForbiddenState card />
      </div>
    );
  return <>{children}</>;
}
